import { useState } from "react";
import Reveal from "@/components/base/Reveal";

export default function SubscribeCta() {
  const [following, setFollowing] = useState(false);
  const [notice, setNotice] = useState("");

  const toggleFollow = () => {
    setFollowing((prev) => {
      const next = !prev;
      setNotice(next ? "已开启更新提醒，新料上架会第一时间同步（演示功能）" : "已关闭更新提醒");
      return next;
    });
  };

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg border border-primary-200 bg-primary-100/70">
            <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-primary-200/50" />
            <div className="absolute -bottom-14 right-24 h-32 w-32 rounded-full bg-secondary-200/50" />
            <div className="relative flex flex-col gap-6 p-6 md:p-10 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-notification-3-line" />
                  更新提醒
                </span>
                <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-primary-950 md:text-3xl">
                  别错过今天的瓜，开启更新提醒
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-primary-900/80 md:text-base">
                  开启后，每当有新的热门爆料上架，你都会在这里看到最新条目。
                  我们只推经过来源标注的内容，不推送待核实线索的提醒。
                </p>
              </div>

              <div className="flex shrink-0 flex-col items-start gap-3">
                <button
                  type="button"
                  onClick={toggleFollow}
                  className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-6 py-3 text-sm font-medium transition-colors ${
                    following
                      ? "bg-accent-600 text-background-50 hover:bg-accent-700"
                      : "bg-primary-500 text-background-50 hover:bg-primary-600"
                  }`}
                >
                  <i className={following ? "ri-checkbox-circle-fill" : "ri-add-circle-line"} />
                  {following ? "已开启提醒" : "订阅今日速递"}
                </button>
                <a
                  href="#board"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3 text-sm text-primary-800 transition-colors hover:border-primary-400"
                >
                  <i className="ri-list-check-2" />
                  直接看热瓜榜
                </a>
              </div>
            </div>
            {notice && (
              <p className="relative px-6 pb-6 text-xs text-primary-800 md:px-10 md:pb-8">{notice}</p>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}